import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "brand-wrapper d-flex justify-content-center align-items-center position-absolute top-0 start-0 bottom-0 end-0"
}
const _hoisted_3 = { class: "edit-wrapper d-flex justify-content-center align-items-center position-absolute end-0" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "img-wrapper d-flex justify-content-center align-items-center" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 1,
  class: "camera-icon d-flex justify-content-center align-items-center bg-white"
}

import { ref, computed } from "vue";
import { useStore } from "vuex";

import { CameraIcon, PencilIcon } from "@/components/svg";

import { RollingLoader } from "@/components/global";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilePicture',
  props: {
    id: {},
    imgSrc: {},
    loading: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit;

const store = useStore();

const profilePictureRef = ref<HTMLInputElement | null>(null);
const removeLogoLoading = computed(() => store.getters["settings/removeLogoLoading"]);

const onFileChange = (e: Event) => {
  const files = (e.target as HTMLInputElement).files;
  if (files) {
    emit('change', files);
  }

  (e.target as HTMLInputElement).value = '';
};

__expose({ profilePictureRef });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    for: __props.id,
    class: "label-profile position-relative"
  }, [
    (__props.loading ?? removeLogoLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(RollingLoader))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(PencilIcon), { class: "text-white" })
    ]),
    _createElementVNode("input", {
      id: __props.id,
      accept: "image/*",
      class: "d-none",
      type: "file",
      onChange: onFileChange,
      "data-testid": "input-fileInput",
      ref_key: "profilePictureRef",
      ref: profilePictureRef
    }, null, 40, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      (__props.imgSrc)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "imgSrc position-absolute w-100 h-100 align-items-center rounded-circle",
            style: {"border":"3px solid #e8eef4"},
            src: __props.imgSrc,
            alt: __props.id ?? 'profile'
          }, null, 8, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(CameraIcon))
          ]))
    ])
  ], 8, _hoisted_1))
}
}

})